import { isPlatform } from '@ionic/vue';
import { computed } from 'vue';

export function useRefresherMode() {
  const mode = computed<'ios' | 'md'>(() => (isPlatform('android') ? 'md' : 'ios'));

  return { mode };
}
